import React, {Component} from 'react'
import PropTypes from 'prop-types'
import autobind from 'autobind-decorator'
import TSelectForm from "../../common/TSelectForm";
import TInputForm from "../../common/TInputForm";

const GoogleAdsenseForMobileOptions = [
    {label: '사용합니다.', value: '0'},
    {label: '사용하지 않습니다.', value: '1'}
]

class TenpingForm extends Component {

    componentDidMount() {
        const { onChange } = this.props
        if (typeof this.props.data.setting.tenpingCode == 'undefined' || this.props.data.setting.tenpingCode == '') {
            onChange(
                Object.assign({}, this.props.data, {
                    validated: false
                })
            )
        }
    }

    @autobind
    handleADCodeChange(ADCode) {
        const {onChange} = this.props
        var newObject = Object();
        newObject['tenpingCode'] = ADCode.target.value;
        onChange(
            Object.assign({}, this.props.data, {
                setting: Object.assign({}, this.props.data.setting, newObject),
                validated: true
            })
        )
    }

    render() {
        const {plugin, data} = this.props
        return (
            <div className="desc_plugin42">
                <p className="txt_plugin" dangerouslySetInnerHTML={{ __html: plugin.rawDescription }} />
                <div className="info_pluginline">
                    <strong className="tit_set">설정 방법</strong>
                    <ol className="list_plugin">
                        <li>
                            <span className="txt_em">1</span>
                            광고 코드 입력창에 텐핑 애드박스 코드를 넣어주세요.
                            <a href="https://blog.naver.com/10ping/221402278553" target="_blank" className="link_other">텐핑 바로가기</a>
                        </li>
                        <li>
                            <span className="txt_em">2</span>
                            적용 버튼을 누르면 설정이 완료됩니다.
                        </li>
                    </ol>
                </div>
                <fieldset>
                    <legend className="tit_set">광고 코드 입력</legend>
                    <textarea className="tf_blog" title="텐핑 애드박스 코드 입력" placeholder="텐핑 애드박스 코드를 넣어주세요." onChange={this.handleADCodeChange}>{this.props.data.setting.tenpingCode}</textarea>
                </fieldset>
                {this.props.saveButton()}
            </div>
        )
    }
}

TenpingForm.propTypes = {
    plugin: PropTypes.object.isRequired,
    data: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired
}

export default TenpingForm
